export default "__VITE_ASSET__LvEmTy59__"